/* eslint-disable import/no-webpack-loader-syntax */
// @ts-expect-error we need to import types here so this is necessary
import utilsTypes from '!!raw-loader!@waylay/sandbox-util/dist/utils.d.ts'

import { normalizeTypeDeclarations } from './utils'

const typeFiles = [utilsTypes]

export default normalizeTypeDeclarations(typeFiles)
